import { render, staticRenderFns } from "./e-iframe-dialog.vue?vue&type=template&id=0a221d5b&scoped=true"
import script from "./e-iframe-dialog.vue?vue&type=script&lang=js"
export * from "./e-iframe-dialog.vue?vue&type=script&lang=js"
import style0 from "./e-iframe-dialog.vue?vue&type=style&index=0&id=0a221d5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a221d5b",
  null
  
)

export default component.exports